module.exports = __webpack_public_path__ + "static/media/logista.b8f9cc38.png";